import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_LIST } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_LIST,
	dropdownList: {
	},
	filter: {
		FirstName: null as null | string,
		LastName: null as null | string,
		DealerKVPS: null as null | string,
		DealerName: null as null | string,
		EmailAddress: null as null | string,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
